import React from "react";
import "./EditProfile.css";
import { IoPersonCircle } from "react-icons/io5";
import { motion } from "framer-motion";

const containerEdit = {
  hidden: {
    opacity: 0,
    x: "100vh",
  },
  visible: {
    opacity: 1,
    x: "0",
    transition:{
        type:"spring",
        stiffness:120
    }
  },
};

const EditProfile = () => {
  return (
    <div className="EditProfile">
      <div className="container">
        <motion.div
          className="container-inside-edit"
          variants={containerEdit}
          initial="hidden"
          animate="visible"
        >
          <div className="edit-content">
            <span>
              <IoPersonCircle />
            </span>
            <h1>Hany Magdy</h1>
            <h5>marwakamel@gmail.com</h5>
            <motion.button
              className="btn-edit-profile"
              whileHover={{ scale: 1.05 }}
            >
              Edit your information
            </motion.button>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default EditProfile;
